export default __webpack_public_path__ + "static/media/map-marker-alt.efd57a22.svg";